var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGearbox = function SvgGearbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.83 3c0-1.1-.9-2-2-2s-2 .9-2 2c0 .84.52 1.55 1.25 1.85v4.49h-5.3V4.79c.67-.32 1.13-1 1.13-1.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .79.46 1.47 1.13 1.79v4.55H3.87V4.79C4.54 4.47 5 3.79 5 3c0-1.1-.9-2-2-2s-2 .9-2 2c0 .79.46 1.47 1.13 1.79v10.96c-.67.32-1.13 1-1.13 1.79 0 1.1.9 2 2 2s2-.9 2-2c0-.79-.46-1.47-1.13-1.79v-4.91h5.17v4.92a2 2 0 0 0-1.12 1.79c0 1.1.9 2 2 2s2-.9 2-2c0-.8-.47-1.48-1.14-1.8v-4.9h6.81v-6c.73-.3 1.25-1.01 1.25-1.85h-.01Z",
    fill: "currentColor"
  })));
};
export default SvgGearbox;